/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ProductInstanceStatusType*`'s.
 */
export type ProductInstanceStatusType =
  | ProductInstanceStatusTypeActivated
  | ProductInstanceStatusTypeActive
  | ProductInstanceStatusTypeReadyToActivate
  | ProductInstanceStatusTypeUnavailable;

/**
 * The product instance activated type.
 * @export
 */
export type ProductInstanceStatusTypeActivated = typeof PRODUCT_INSTANCE_STATUS_ACTIVATED;

/**
 * The product instance active type.
 * @export
 */
export type ProductInstanceStatusTypeActive = typeof PRODUCT_INSTANCE_STATUS_ACTIVE;

/**
 * The product instance ready to activate type.
 * @export
 */
export type ProductInstanceStatusTypeReadyToActivate = typeof PRODUCT_INSTANCE_STATUS_READY_TO_ACTIVATE;

/**
 * The product instance unavailable type.
 * @export
 */
export type ProductInstanceStatusTypeUnavailable = typeof PRODUCT_INSTANCE_STATUS_UNAVAILABLE;

/**
 * The product instance activated constant.
 * @export
 */
export const PRODUCT_INSTANCE_STATUS_ACTIVATED = `Activated`;

/**
 * The product instance active constant.
 * @export
 */
export const PRODUCT_INSTANCE_STATUS_ACTIVE = `Active`;

/**
 * The product instance ready to activate constant.
 * @export
 */
export const PRODUCT_INSTANCE_STATUS_READY_TO_ACTIVATE = `Ready to activate`;

/**
 * The product instance unavailable constant.
 * @export
 */
export const PRODUCT_INSTANCE_STATUS_UNAVAILABLE = `Unavailable`;
